import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { KalDialogRef, KalSelectionModel } from '@kalidea/kaligraphi';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { UserState } from 'src/app/_user/store/user/user.state';
import { BaseV2Model } from 'src/graphql/generated-types';

@Component({
    selector: 'app-super-admin',
    templateUrl: './super-admin-dialog.component.html',
    styleUrls: ['./super-admin-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SuperAdminDialogComponent extends BaseComponent implements OnInit, OnDestroy {

    @Select(UserState.ceList) ceList$: Observable<BaseV2Model[]>;

    displayedCEList: BaseV2Model[] = [];

    control = new UntypedFormControl();

    selection = new KalSelectionModel<{ id?: string } & BaseV2Model>();

    constructor(protected cdr: ChangeDetectorRef,
                private dialogRef: KalDialogRef<SuperAdminDialogComponent>) {
        super(cdr);
    }

    selectRow(selection: KalSelectionModel<{ id: string } & BaseV2Model>): void {
        this.selection = selection;
    }

    submitDialog(): void {
        this.dialogRef.close({selectedCE: this.selection.added[0]});
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    private handleSearchbar(search: string): void {
        // Si une base n'a pas d'InitialCatalog on ne peut pas s'y connecter.
        const ceList = this.snapshot(UserState.ceList).filter(({InitialCatalog}) => !!InitialCatalog);
        if (!search) {
            this.displayedCEList = ceList;
        } else {
            this.displayedCEList = ceList.filter(ce => {
                return [ce.NomBase || '', ce.InitialCatalog]
                    .map(e => e?.toLocaleLowerCase())
                    .some(e => e.includes(search.toLocaleLowerCase()));
            });
        }
    }

    ngOnInit(): void {
        this.watch$ = this.ceList$.pipe(
            tap((ceList: BaseV2Model[]) => this.displayedCEList = ceList.filter(({InitialCatalog}) => !!InitialCatalog))
        );

        this.watch$ = this.control.valueChanges.pipe(tap(value => this.handleSearchbar(value)));
    }

}
